import type { Units } from '@turf/turf';
import { calculateLength } from '~/helpers/unitHelpers';
import type { Point } from '../SurfaceBase';
import type VertexObject from '../VertexObject';

export const measureColor = 'rgb(255, 0, 0)';
export const measureFillColor = 'rgb(255, 0, 0, 0.25)';
export const measureLineWidth = 2;
export const measureLineDash = [15, 10];
export const padding = 10;
export const fontSize = 14;

interface SegmentData {
  point: Point;
  length: {
    value: number;
    unit: string | undefined;
  };
  rotation: number;
}

export function getSegmentData(
  v1: VertexObject,
  v2: VertexObject,
  unitType: Units,
  unitSystem: 'imperial' | 'metric',
): SegmentData {
  // text label point location on canvas:
  const p1 = v1.point;
  const p2 = v2.point;

  const point = {
    x: p1.x + (p2.x - p1.x) / 2,
    y: p1.y + (p2.y - p1.y) / 2,
  };

  // segment geographical length:
  const length = calculateLength({
    unitType,
    unitSystem,
    geometry: {
      type: 'LineString',
      coordinates: [
        [v1.lngLat.lng, v1.lngLat.lat],
        [v2.lngLat.lng, v2.lngLat.lat],
      ],
    },
  });

  // label rotation value:
  const rawRotation = Math.atan2(p2.y - p1.y, p2.x - p1.x);
  let rotation: number;
  if (rawRotation >= Math.PI / 2 && rawRotation <= Math.PI) {
    rotation = -1 * Math.PI + rawRotation;
  } else if (rawRotation > -1 * Math.PI && rawRotation < (-1 * Math.PI) / 2) {
    rotation = Math.PI + rawRotation;
  } else {
    rotation = rawRotation;
  }

  return { point, length, rotation };
}
